export const CREATE_REQUEST = "SUPPORT::CREATE_REQUEST";
export const SHOW_CONTACT_FORM_MODAL = "SUPPORT::SHOW_CONTACT_FORM_MODAL";
export const HIDE_CONTACT_FORM_MODAL = "SUPPORT::HIDE_CONTACT_FORM_MODAL";
